import { defaultTo, get, map, pipe, placeholder, replace } from 'lodash/fp';

export const date_int_to_date = date_int =>
(
  new Date
  (
    new Date('1970-01-02').getTime() * date_int
  )
  .toISOString()
  .slice(0, 10)
);

export const date_int_to_weekday = date_int =>
(
  new Date
  (
    date_int_to_date(date_int)
  )
  .getUTCDay()
);

export const date_int_to_date_of_month = date_int =>
(
  new Date
  (
    date_int_to_date(date_int)
  )
  .getUTCDate()
);

export const date_to_date_int = date =>
(
  new Date(date).getTime() / new Date('1970-01-02').getTime()
);

export const date_int_to_from_date_int = date_int =>
(
  date_to_date_int
  (
    new Date
    (
      new Date
      (
        date_int_to_date(date_int)
      )
      .setUTCDate(1)
    )
    .toISOString()
    .slice(0, 10)
  )
);

export const get_date_int_today = () =>
(
  date_to_date_int
  (
    new Date
    (
      Date.UTC
      (
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      )
    )
    .toISOString()
    .slice(0, 10)
  )
);

export const timestamp_to_date_int = timestamp =>
(
  date_to_date_int
  (
    new Date
    (
      Date.UTC
      (
        new Date(timestamp).getFullYear(),
        new Date(timestamp).getMonth(),
        new Date(timestamp).getDate(),
      )
    )
    .toISOString()
    .slice(0, 10)
  )
);

export const date_int_to_timestamp = date_int =>
(
  new Date
  (
  )
  .setFullYear
  (
    new Date(date_int_to_date(date_int)).getUTCFullYear(),
    new Date(date_int_to_date(date_int)).getUTCMonth(),
    new Date(date_int_to_date(date_int)).getUTCDate(),
  )
);

export const update_timestamp_with_date_int = date_int => timestamp =>
(
  new Date
  (
    timestamp
  )
  .setFullYear
  (
    new Date(date_int_to_date(date_int)).getUTCFullYear(),
    new Date(date_int_to_date(date_int)).getUTCMonth(),
    new Date(date_int_to_date(date_int)).getUTCDate(),
  )
);

export const keyToLabel = key =>
{
  const labels =
  {
    added_sugars: 'Added Sugars',
    calcium: 'Calcium',
    calories: 'Calories',
    carbohydrate: 'Carbs',
    cholesterol: 'Cholesterol',
    fat: 'Fat',
    fiber: 'Fiber',
    iron: 'Iron',
    monounsaturated_fat: 'Monounsaturated Fat',
    polyunsaturated_fat: 'Polyunsaturated Fat',
    potassium: 'Potassium',
    protein: 'Protein',
    saturated_fat: 'Saturated Fat',
    sodium: 'Sodium',
    sugar: 'Sugar',
    trans_fat: 'Trans Fat',
    vitamin_a: 'Vitamin A',
    vitamin_c: 'Vitamin C',
    vitamin_d: 'Vitamin D',
  };

  return pipe
  ([
    get(placeholder, labels),
    defaultTo(key),
  ])
  (key);
};

export const keyToLabelHtml = key =>
{
  return pipe
  ([
    keyToLabel,
    replace(/ /g)('&nbsp;'),
  ])
  (key);
};

export const keyToUnit = key =>
{
  const units =
  {
    added_sugars: 'g',
    calcium: 'mg',
    calories: 'kcal',
    carbohydrate: 'g',
    cholesterol: 'mg',
    fat: 'g',
    fiber: 'g',
    iron: 'mg',
    monounsaturated_fat: 'g',
    polyunsaturated_fat: 'g',
    potassium: 'mg',
    protein: 'g',
    saturated_fat: 'g',
    sodium: 'mg',
    sugar: 'g',
    trans_fat: 'g',
    vitamin_a: 'mcg',
    vitamin_c: 'mg',
    vitamin_d: 'mcg',
  };

  return pipe
  ([
    get(placeholder, units),
    defaultTo(''),
  ])
  (key);
};

export const mealToLabel = meal =>
{
  const labels =
  {
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    other: 'Other',
  };

  return pipe
  ([
    get(placeholder, labels),
    defaultTo(meal),
  ])
  (meal);
};

export const labelToMeal = label =>
{
  const meals =
  {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner',
    Other: 'other',
  };

  return pipe
  ([
    get(placeholder, meals),
    defaultTo(label),
  ])
  (label);
};

export const foodParamToLabel = key =>
{
  const labels =
  {
    brand_type: 'Who makes this food?',
    brand_name: 'Manufacturer name (e.g.: Kraft)',
    food_name: 'Food or Product name (e.g.: Swiss Cheese Singles)',
    serving_size: 'Serving Size (e.g.: 1 Package or 1/2 Cup)',
    serving_amount: 'Serving Amount',
    serving_amount_unit: 'Serving Amount Unit',
    calories_from_fat: 'Calories From Fat',
  };

  return pipe
  ([
    get(placeholder, labels),
    defaultTo(key),
    keyToLabel,
  ])
  (key);
};

export const nutrients =
[
  'calories',
  'fat',
  'saturated_fat',
  'trans_fat',
  'monounsaturated_fat',
  'polyunsaturated_fat',
  'cholesterol',
  'sodium',
  'carbohydrate',
  'fiber',
  'sugar',
  'added_sugars',
  'protein',
  'vitamin_a',
  'vitamin_c',
  'vitamin_d',
  'calcium',
  'iron',
  'potassium',
];

export const food_entries_to_saved_meal_items = saved_meal_id => food_entries =>
(
  map(({
    food_id,
    food_entry_name: saved_meal_item_name,
    serving_id,
    number_of_units,
  }) => ({
    saved_meal_id,
    food_id,
    saved_meal_item_name,
    serving_id,
    number_of_units,
  }))
  (food_entries)
);